import { render } from "./LegacyEmailContentHeaders.vue?vue&type=template&id=34ecee06"
import script from "./LegacyEmailContentHeaders.vue?vue&type=script&lang=js"
export * from "./LegacyEmailContentHeaders.vue?vue&type=script&lang=js"
script.render = render

export default script